import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import styled from "styled-components"
import tw from "twin.macro"
import { navLinks } from "@config"

const StyledMenu = styled.nav`
  ${tw`flex items-center fixed bottom-4 left-8 rounded-lg bg-neutralDark px-4 z-10 h-16 border-0 border-b-4 border-solid border-amaranth md:hidden`}
  width: calc(100% - 4rem);
  box-shadow: 0 20px 20px 10px rgba(0, 0, 0, 0.25);
  & {
    .nav {
      ${tw`
        flex items-center justify-between list-none w-full m-0 p-0 
        md:justify-start md:gap-10 lg:gap-20 
      `}
      .nav-items {
        a {
          ${tw`flex text-neutralLight no-underline transition-colors hover:text-deepSky focus:text-deepSky`}
          .nav-items__icon {
            ${tw`block w-full h-full flex items-center justify-center`}
          }
        }
      }
    }
  }
`

const Menu = ({ renderNavIcon }) => (
  <StyledMenu>
    <ul className="nav">
      {navLinks.map(({ url, icon }, i) => (
        <li className="nav-items" key={i}>
          <Link to={url}>
            <span className="nav-items__icon">{renderNavIcon(icon)}</span>
          </Link>
        </li>
      ))}
    </ul>
  </StyledMenu>
)

Menu.propTypes = {
  renderNavIcon: PropTypes.func.isRequired,
}

export default Menu
